import React from 'react'

type Props = {
  isTeammate?: boolean
}
export default function DiscordSection({ isTeammate = false }: Props) {
  // const buttonClassName =
  //   'text-body-bold mt-2 flex h-11 w-full flex-row items-center justify-center gap-3 bg-[#5A66DB] px-2 text-white hover:bg-[#5A66DB] hover:opacity-70'

  return (
    <div className='px-5 pb-5 pt-3.5 w-full bg-fizz-900 flex flex-col gap-1'>
      <p className='text-body-semibold text-white'>
        {isTeammate
          ? 'Invite the customer to Discord:'
          : 'If you want to Voice Chat:'}
      </p>

      <p className='text-secondary-normal text-white'>
        {isTeammate
          ? "Ask the customer if they'd like to voice chat"
          : 'Your teammate(s) will invite you to Discord shortly. If you encounter any difficulties, please contact our support team.'}
      </p>

      {/*<a*/}
      {/*  className={buttonClassName}*/}
      {/*  href={'https://discord.com/invite/tapingg'}*/}
      {/*  target={'_blank'}*/}
      {/*  rel='noreferrer'*/}
      {/*>*/}
      {/*  <div className='relative h-6 w-6'>*/}
      {/*    <Image*/}
      {/*      src={DiscordIcon}*/}
      {/*      className='rounded-full object-contain'*/}
      {/*      fill={true}*/}
      {/*      alt='Discord icon'*/}
      {/*    />*/}
      {/*  </div>*/}
      {/*  Join Discord Chat*/}
      {/*</a>*/}

      {/*{isTeammate ? (*/}
      {/*  <a*/}
      {/*    className={buttonClassName}*/}
      {/*    href={data.url}*/}
      {/*    target={'_blank'}*/}
      {/*    rel='noreferrer'*/}
      {/*  >*/}
      {/*    <div className='relative h-6 w-6'>*/}
      {/*      <Image*/}
      {/*        src={DiscordIcon}*/}
      {/*        className='rounded-full object-contain'*/}
      {/*        fill={true}*/}
      {/*        alt='Discord icon'*/}
      {/*      />*/}
      {/*    </div>*/}
      {/*    Join Discord Chat*/}
      {/*  </a>*/}
      {/*) : (*/}
      {/*  <button*/}
      {/*    className={buttonClassName}*/}
      {/*    onClick={(e) => {*/}
      {/*      e.preventDefault()*/}
      {/*      if (*/}
      {/*        !user?.socialAccounts?.some((account: any) => {*/}
      {/*          return account.providerName === 'discord'*/}
      {/*        }) &&*/}
      {/*        user?.communicationProfile?.discordId == null*/}
      {/*      ) {*/}
      {/*        window.open(*/}
      {/*          process.env.NEXT_PUBLIC_DISCORD_IN_SESSION_URL!,*/}
      {/*          '_blank',*/}
      {/*        )*/}
      {/*      } else {*/}
      {/*        window.open(data.url, '_blank')*/}
      {/*      }*/}

      {/*      captureJoinDiscordEvent(id?.toString() ?? '')*/}
      {/*    }}*/}
      {/*  >*/}
      {/*    <div className='relative h-6 w-6'>*/}
      {/*      <Image*/}
      {/*        src={DiscordIcon}*/}
      {/*        className='rounded-full object-contain'*/}
      {/*        fill={true}*/}
      {/*        alt='Discord icon'*/}
      {/*      />*/}
      {/*    </div>*/}
      {/*    Join Discord Chat*/}
      {/*  </button>*/}
      {/*)}*/}
    </div>
  )
}
